import { useState, useEffect, useCallback } from 'react';

declare global {
  interface Window {
    consentPolicyManager?: {
      getCurrentConsentPolicy?: () => {
        policy: {
          advertising?: boolean;
        };
      };
    };
  }
}

export const useConsentPolicy = () => {
  const [isAdvertisingAllowed, setIsAdvertisingAllowed] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const checkConsentPolicy = useCallback(() => {
    try {
      const consentManager = window.consentPolicyManager;
      if (consentManager) {
        const consentData = consentManager.getCurrentConsentPolicy?.();
        const advertisingAllowed = Boolean(consentData?.policy?.advertising);
        setIsAdvertisingAllowed(advertisingAllowed);
      }
    } catch (error) {
      console.warn('Failed to get consent policy:', error);
      setIsAdvertisingAllowed(false);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    checkConsentPolicy();

    const handleConsentChange = (event: Event) => {
      const consentEvent = event as CustomEvent;
      try {
        const advertisingAllowed = Boolean(
          consentEvent.detail?.policy?.advertising,
        );
        setIsAdvertisingAllowed(advertisingAllowed);
      } catch (error) {
        console.warn('Failed to handle consent policy change:', error);
      }
    };

    window.addEventListener('consentPolicyChanged', handleConsentChange);

    return () => {
      window.removeEventListener('consentPolicyChanged', handleConsentChange);
    };
  }, [checkConsentPolicy]);

  return {
    isAdvertisingAllowed,
    isLoading,
  };
};
